import template from './employee_view_history_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import parseLogs from '../../lib/sf_system_log.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewHistoryComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee = ko.observable();
		this.employee_id = ko.observable();
		this.system_logs = ko.observableArray();
		this.query = ko.observable('');
		this.offset = ko.observable(0);
		this.limit = ko.observable(50);
		this.has_more = ko.observable(false);
		this.loadmore_visible = ko.observable(false);
		this.logged_dates = ko.observableArray();
		this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');
		this.user_access_roles = ko.observableArray();
		this.loader = ko.observable(false);

		if (bindings.employee && ko.isObservable(bindings.employee))
		{
			bindings.employee.subscribe((nv) => {
				if (nv)
				{
					this.employee(nv);
					this.employee_id(nv.employee_id);
					this.updateData();
				}
			});
		}

		if (bindings.employee_id && ko.isObservable(bindings.employee_id))
			bindings.employee_id.subscribe((nv) => { this.employee_id(nv); });
	}

	async updateData()
	{
		this.loadPage();
	};
	
	show_employee_history_help()
	{
		Grape.dialog.open('EmployeeHistoryLogHelp', { employee_id: this.logged_in_employee_id });
	}

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	async loadPage()
	{
		// employee log
		this.system_logs.removeAll();
		this.logged_dates.removeAll();
		this.loadmore_visible(false);
		this.has_more(true);
		await this.load_employee_log();
	};

	/** employee log functions start **/
	enter_search_click(v, e)
	{
		e.key === 'Enter' && this.search();
		return true;
	};

	async search()
	{
		// clear everything and redo
		this.loader(true);

		this.system_logs.removeAll();
		this.offset(0);
		this.logged_dates.removeAll();
		this.load_employee_log();

		this.loader(false);
	};

	async loadmore()
	{
		if (this.has_more())
		{
			this.offset(this.offset() + this.limit());
			this.load_employee_log();
		}
	};

	async load_employee_log()
	{
		let log_filters = [
			{ value: this.employee_id(), op: '=', field: 'affected_employee_id' }
		];
		
		let qry = this.query().trim();
		
		if (qry.length)
			log_filters.push({ value: '%' + qry.toLowerCase() + '%', op: 'LIKE', field: 'searchfield' });
		
		// employee log
		let options = {
			table: 'v_system_logs',
			schema: 'savanna',
			limit: this.limit(),
			offset: this.offset(),
			filter: log_filters
		}

		let res = await Grape.fetches.getJSON('/api/record', options);
		if (res.status == 'OK')
		{
			if (res.records == null && this.offset() == 0)
			{
				this.system_logs.removeAll();
				this.logged_dates.removeAll();
				this.loadmore_visible(false);
				this.has_more(false);
			}
			else
			{
				this.loadmore_visible(true);

				// hide the load more if there wont be next batch to load. ( there's a 1% change that we load exactly same a limit ... )
				if (res.records == null || res.records.length < this.limit())
				{
					this.loadmore_visible(false);
					this.has_more(false);
				};

				if (res.records)
				{
					let parsed_records = parseLogs(res.records, this.logged_dates);
					this.system_logs(this.system_logs().concat(parsed_records));
				};
			};
		};
	};
};

export default {
	name: 'employee_view_history_component',
	viewModel: EmployeeViewHistoryComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_history_component'
};
